// Findability version, prepended to every search query for future measurement
export const FINDABILITY_MVI = 4
